import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=4819ad26&scoped=true&"
import script from "./activity-list.vue?vue&type=script&lang=js&"
export * from "./activity-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=4819ad26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819ad26",
  null
  
)

export default component.exports